import { Component, HostListener, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-iframe-scaler',
  templateUrl: './iframe-scaler.component.html',
  styleUrls: ['./iframe-scaler.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class IframeScalerComponent implements OnInit{
  @Input() src:string;
  scale = 0.5; // Default scale
  safeUrl: SafeResourceUrl;


  constructor(
    private sanitizer: DomSanitizer
  ) {
    // this.updateScale(window.innerWidth); // Initialize scale based on initial width


  }
  ngOnInit(): void {
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.src);
    // console.log(this.safeUrl);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    // this.updateScale(event.target.innerWidth);
  }

  // updateScale(width: number) {
  //   if (width > 1920) this.scale = 0.6;
  //   else if (width > 1280) this.scale = 0.4;
  //   else if (width > 720) this.scale = 0.3;
  //   else this.scale = 0.2;
  // }
}
